export const DEFAULT_MAX_FILES_PER_SLOT = 6;
export const DEFAULT_MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;
export const THUMBNAIL_WIDTH = 80;

const mimeLabels = {
  'application/pdf': 'PDF',
  'text/plain': 'TXT',
  'image/jpeg': 'JPG',
  'image/png': 'PNG',
  'image/webp': 'WEBP',
  'image/heic': 'HEIC',
  'image/heif': 'HEIF',
};

export const ALLOWED_MIME_TYPES = Object.keys(mimeLabels);

const mimeToExtensions = {
  'application/pdf': ['.pdf'],
  'text/plain': ['.txt'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
  'image/webp': ['.webp'],
  'image/heic': ['.heic'],
  'image/heif': ['.heif'],
};

export const getAcceptAttribute = (allowedMimeTypes = ALLOWED_MIME_TYPES) =>
  allowedMimeTypes.flatMap((m) => mimeToExtensions[m] || []).join(',');

export const getMimeLabel = (mimeType) => mimeLabels[mimeType] || mimeType;

export const isImageMime = (mimeType) => !!mimeType && mimeType.startsWith('image/');

export const getThumbnailUrl = (url, width = THUMBNAIL_WIDTH) => {
  if (!url) return undefined;
  const [base, fragment] = url.split('#');
  const sep = base.includes('?') ? '&' : '?';
  const withParam = `${base}${sep}width=${width}`;
  return fragment ? `${withParam}#${fragment}` : withParam;
};

export const getCottageName = (cottage) => {
  if (!cottage) return '';
  return cottage.title_sv || cottage.title || cottage.headline || cottage.name || `#${cottage.id}`;
};

export const getFileDisplayName = (file) => file.display_name || file.filename || '';

export const sortFilesByName = (files) =>
  [...(files || [])].sort((a, b) =>
    getFileDisplayName(a).toLowerCase().localeCompare(getFileDisplayName(b).toLowerCase(), 'sv'),
  );

export const sortCottagesByName = (cottages) =>
  [...(cottages || [])].sort((a, b) =>
    getCottageName(a).toLowerCase().localeCompare(getCottageName(b).toLowerCase(), 'sv'),
  );

export const formatFileSize = (bytes) => {
  if (bytes == null) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};
